export default __webpack_public_path__ + "static/media/lux-bg.65618b22.jpg";